import { useGetAllGiveaways } from '@bpm-web-app/swr-hooks';
import ContestsGrid from '../contests-grid/contests-grid';
import styles from './current-contests.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CurrentContestsProps { }

export function CurrentContests(props: CurrentContestsProps) {
    const { data, isLoading, error } = useGetAllGiveaways();

    if (isLoading || error || data.data.current.length === 0) return <div />;

    return (
        <div className={styles['current-contests']}>
            <h2 className={styles['current-contests__title']}>Current Contests</h2>
            <div className={styles['current-contests__grid']}>
                <ContestsGrid contests={data.data.current} />
            </div>
        </div>
    );
}

export default CurrentContests;
